import {Paper} from '@mui/material';

const SelectFieldPaper = (props) => {
  return (
    <Paper
      {...props}
      sx={{
        marginTop: '5px',
        textAlign: 'center',
        '& .MuiAutocomplete-listbox': {
          '& li': {
            display: ' inline-block',
            width: '90%',
          },

          color: '#707070',
          width: '100%',
          bgColor: 'transparent',
          "& .MuiAutocomplete-option[aria-selected='true']": {
            color: 'purple',
            bgColor: 'transparent',
            '&.Mui-focused': {
              color: 'purple',
            },
          },
        },
      }}
    />
  );
};

export default SelectFieldPaper;
